import React from 'react';

const HIGHLIGHT_CLASS = 'wa-highlight';
const HIGHLIGHT_DURATION_MS = 600;

const useScrollToMessage = () => {
    const scrollToMessage = React.useCallback((messageId, options = {}) => {
        if (messageId == null) return;
        const id = Number.parseInt(messageId, 10);
        if (!Number.isFinite(id)) {
            // eslint-disable-next-line no-console
            console.warn(`[useScrollToMessage] non-numeric messageId rejected: ${messageId}`);
            return;
        }
        const { highlight = true } = options;
        const el = document.querySelector(`[data-message-id="${id}"]`);
        if (!el) {
            // eslint-disable-next-line no-console
            console.warn(`[useScrollToMessage] message ${id} not found in DOM`);
            return;
        }
        if (typeof el.scrollIntoView === 'function') {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (highlight) {
            el.classList.add(HIGHLIGHT_CLASS);
            setTimeout(() => {
                el.classList.remove(HIGHLIGHT_CLASS);
            }, HIGHLIGHT_DURATION_MS);
        }
    }, []);

    return { scrollToMessage };
};

export default useScrollToMessage;
